import { useTimezone } from '@app/core/hooks/useTimezone';
import { DateTimeField } from '@mi-front/ui';
import { Grid } from '@mui/material';
import moment from 'moment-timezone';
import { defineMessage, useIntl } from 'react-intl';

const dateStartMessage = defineMessage({
  id: 'common.dateStart',
  defaultMessage: 'Fecha inicio',
});

const timeStartMessage = defineMessage({
  id: 'common.timeStart',
  defaultMessage: 'Hora inicio',
});

const dateEndMessage = defineMessage({
  id: 'common.dateEnd',
  defaultMessage: 'Fecha fin',
});

const timeEndMessage = defineMessage({
  id: 'common.timeEnd',
  defaultMessage: 'Hora fin',
});

interface AuditDateTimeRangeFieldsProps {
  fromName?: string;
  toName?: string;
}

/**
 * Renders the standard start and end date-time fields shared by station-audit filters.
 */
export function AuditDateTimeRangeFields({
  fromName = 'from',
  toName = 'to',
}: AuditDateTimeRangeFieldsProps) {
  const { $t } = useIntl();
  const tz = useTimezone();

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={6} lg={4}>
        <DateTimeField
          name={fromName}
          dateLabel={$t(dateStartMessage)}
          timeLabel={$t(timeStartMessage)}
          isOutsideRange={(date) => moment(date) > moment()}
          tz={tz}
        />
      </Grid>
      <Grid item xs={12} md={6} lg={4}>
        <DateTimeField
          name={toName}
          dateLabel={$t(dateEndMessage)}
          timeLabel={$t(timeEndMessage)}
          isOutsideRange={(date) => moment(date) > moment()}
          tz={tz}
        />
      </Grid>
    </Grid>
  );
}
